import store from "@/store";

export default function (message: unknown, color: string, timeout?: number): void {
  store.commit("snackbar/show", { message, color, timeout });
}
